import React, { useState, useEffect } from 'react'
import styles from './FluIndices.module.scss'
import getVectorImage from '../../utils/getVectorImage'
import { useGeoFetch, useGeoState } from '../../components/GeoProvider'
import dayjs from 'dayjs'
import typeDisplayOptions from '../Dashboard/typeDisplayOptions'
import SelectList from '../../components/SelectList'
import DefaultBreadcrumbs from '../../components/Breadcrumbs/DefaultBreadcrumbs'
import regionDisplayOptions from './regionDisplayOptions'
import MapOptions from '../../components/MapOptions'
import { useHistory } from 'react-router-dom'
import dataDisplayOptions from './dataDisplayOptions'
const HeaderDisplay = ({ headerType }) => {
  const lastweekEndDate = dayjs().day(-1).format('YYYY-MM-DD')

  const [getgeoid, setgeoid] = useState('')
  const [getistrue, setistrue] = useState('')
  const [getDatavalue, setDatavalue] = useState('')
  const [getPercentage, setPercentage] = useState('')
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const { setLocationName } = useGeoState()
  const { data: headerdata, error: stateDataError } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'vulnerability',
    'getheader/' + headerType,
    false,'',
    'GET'
  )
  useEffect(() => {
    if (headerdata !== null && headerdata !== undefined) {
      if (headerdata.response_code === 200) {
        if (
          headerdata.response_data !== null &&
          headerdata.response_data !== undefined
        ) {
          setgeoid(headerdata.response_data.geo_id)
          setDatavalue(headerdata.response_data.vulnerability_index)
          setistrue(
            headerdata.response_data.change_percentage > 0 ? true : false
          )
          setPercentage(Math.abs(headerdata.response_data.change_percentage))
          setLocationName(headerdata.response_data.geo_name)
        }
      } else {
        setErrorSubject(headerdata.response_subject)
        seterrorOccured(true)
      }
    }
  }, [headerdata])

  if (stateDataError || errorOccured) {
    return (
      <div>
        {errorSubject !== undefined
          ? errorSubject
          : 'Unable to get the data for header'}{' '}
        : {errorSubject}
      </div>
    )
  }
  return (
    <>
      <span className={styles.firstSpan}> {getgeoid}</span>
      <span className={styles.secondSpan}>{getVectorImage(getistrue)}</span>
      <span className={getistrue ? styles.stdatavalueup : styles.datavaluedown}>
        {' '}
        {getPercentage}%{' '}
      </span>
      <span className={styles.forthSpan}> ({getDatavalue})</span>
      {/* <span className={styles.firstSpan}> {getgeoid}</span>
      <span className={styles.forthSpan}> {getDatavalue}</span> */}
    </>
  )
}

const Header = ({ headerType, headerNumber }) => {
  const history = useHistory()
  const [activeCbsa, setActiveCbsa] = useState()
  const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
    '',
    '',
    'vulnerability',
    'searchlocations/vulnerability',
    false,
    {geo_type:'MSA'}
  )

  useEffect(() => {
    if (activeCbsasData !== null && activeCbsasData !== undefined) {
      if (activeCbsasData.response_code === 200) {
        setActiveCbsa(activeCbsasData.response_data)
      }
    }
  }, [activeCbsasData])
  return (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          <DefaultBreadcrumbs
            geo_id={'NAT'}
            geo_type={'NAT'}
            dashboardType={'VULNERABILITY'}
          />
          <SelectList
            dropdownData={typeDisplayOptions}
            defaultValue={'vulnerability'}
            defaultLabel={'Vulnerability'}
          />
        </div>
        <div className={styles.pageHeaderTextValue}>
          <HeaderDisplay
            headerType={headerType}
            dashNo={headerNumber}
          ></HeaderDisplay>
          <MapOptions
            regionDisplayOptions={regionDisplayOptions}
            dataDisplayOptions={dataDisplayOptions}
            activeCbsa={activeCbsa}
            mapType={'Vulnerability'}
          />
        </div>
      </div>
    </>
  )
}
export default Header
